import { Link } from "react-router-dom";
import SceneCard from "../components/SceneCard";
import NewsCard from "../components/NewsCard";
import {
  announcements,
  company,
  enterpriseNews,
  partners,
  products,
  scenes,
} from "../data/site";

export default function Home() {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-visual" aria-hidden="true">
          <div className="grid-lines" />
          <div className="horizon" />
          <div className="pavilion" />
          <div className="wave" />
        </div>
        <div className="container hero-copy">
          <p className="eyebrow">Hainan · Sanya · Metaverse</p>
          <h1>
            {company.shortName}
            <small>{company.englishName}</small>
          </h1>
          <p className="hero-slogan">{company.slogan}</p>
          <p className="hero-lead">
            扎根海南自贸港，以人工智能、XR 与数字孪生连接文化、文旅与文娱，
            让虚拟世界与三亚的山海同频。
          </p>
          <div className="hero-actions">
            <a
              className="btn btn-primary"
              href={company.productSite}
              target="_blank"
              rel="noreferrer"
            >
              立即下载
            </a>
            <Link className="btn btn-ghost" to="/about-us">
              了解我们
            </Link>
          </div>
        </div>
      </section>

      <section className="intro-strip">
        <div className="container">
          <p>
            {company.name}是{company.parent}全资子公司，上市公司控股的文化元宇宙平台在海南的落地主体。
            公司围绕元宇宙+文化、元宇宙+文旅、元宇宙+文娱，为政府、景区与企业提供虚实融合解决方案。
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <header className="section-head">
            <div>
              <p className="eyebrow">News</p>
              <h2>新闻</h2>
            </div>
            <Link to="/news" className="text-link">
              查看全部
            </Link>
          </header>
          <div className="news-grid">
            {enterpriseNews.slice(0, 3).map((item) => (
              <NewsCard key={item.id} news={item} featured />
            ))}
          </div>
        </div>
      </section>

      <section className="section board-section">
        <div className="container board">
          <div className="board-title">
            <h2>公告</h2>
            <span>ANNOUNCEMENTS</span>
          </div>
          <ul>
            {announcements.map((item) => (
              <li key={item.title}>
                <time>{item.date}</time>
                <span>{item.title}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <header className="section-head">
            <div>
              <p className="eyebrow">Products</p>
              <h2>产品信息</h2>
            </div>
            <Link to="/product" className="text-link">
              了解产品
            </Link>
          </header>
          <div className="product-grid">
            {products.map((item) => (
              <Link
                key={item.id}
                to={`/product?tab=${item.tab}`}
                className="product-tile"
              >
                <span className="tile-index">0{item.tab.slice(-1)}</span>
                <h3>{item.name}</h3>
                <p>{item.summary}</p>
              </Link>
            ))}
          </div>
          <div className="scene-grid">
            {scenes.map((scene) => (
              <SceneCard key={scene.name} {...scene} />
            ))}
          </div>
        </div>
      </section>

      <section className="section partner-strip">
        <div className="container">
          <header className="section-head">
            <div>
              <p className="eyebrow">Partners</p>
              <h2>合作伙伴</h2>
            </div>
            <Link to="/partner" className="text-link">
              全部伙伴
            </Link>
          </header>
          <div className="logo-wall">
            {partners.map((p) => (
              <div className="logo-chip" key={p.name}>
                <strong>{p.name}</strong>
                <small>{p.en}</small>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
